import React from 'react';
import type { FormikProps } from 'formik';
import { Form, FieldArray } from 'formik';

import IconButton from '@mui/material/IconButton';

import Image from 'src/components/ui/Image';
import Video from 'src/components/ui/Video';
import Icon from 'src/components/ui/Icon';
import { colours } from 'src/constants/colours';
import type { Medium } from 'src/types/__generated__/graphql';
import { styledComponent, styledTag } from 'src/utils/styled';

const ImagesPart = styledTag('div')`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 1rem;
    > div {
        margin: 1rem 0 0 0;
    }
    margin-bottom: 0.5rem;
`;

const RectangleImage = styledTag('label')`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 0.375rem;
    cursor: pointer;
    overflow: hidden;
    img,
    video {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
    position: relative;
    height: 5rem;
`;

const StyledTrashIconButton = styledComponent(IconButton)`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 10;
    padding: 0.2rem;
    background-color: ${colours.white.main}40;
`;

type CustionMedium = Medium & { file?: File; src?: string };

interface FormValues {
    media: CustionMedium[];
}

type Props = {
    media?: CustionMedium[];
    name: string;
    propsFormikMedia?: FormikProps<FormValues>;
};

const ImagePartPostModal: React.FC<Props> = ({ media, name, propsFormikMedia }) => (
    <Form>
        <FieldArray
            name={name}
            validateOnChange={false}
            render={(arrayHelpers) => (
                <ImagesPart>
                    {media?.map(({ src, file, type, url, size, id, isTranscoding }, index) => (
                        <RectangleImage key={file !== undefined ? `${file.name}-${file.size}` : `${id}-${size}`}>
                            <StyledTrashIconButton
                                onClick={() => {
                                    arrayHelpers.remove(index);
                                    propsFormikMedia?.setFieldTouched('media');
                                }}
                            >
                                <Icon name="Delete" size="1rem" color={colours.primary.main} />
                            </StyledTrashIconButton>
                            {file !== undefined &&
                                src &&
                                (file.type.includes('image') ? (
                                    <Image src={src} alt="label" fill />
                                ) : (
                                    <Video src={src} isTranscoding={Boolean(isTranscoding)} muted />
                                ))}
                            {file === undefined &&
                                (type.includes('image') ? (
                                    <Image src={url} alt="label" fill />
                                ) : (
                                    <Video src={url} isTranscoding={Boolean(isTranscoding)} muted />
                                ))}
                        </RectangleImage>
                    ))}
                </ImagesPart>
            )}
        />
    </Form>
);

export default ImagePartPostModal;
